export const SET_DARK_MODE = 'SET_DARK_MODE';

export const SET_WHITE_MODE = 'SET_WHITE_MODE';

export const setDarkMode = () => {
    return {
        type : SET_DARK_MODE,
    };
};

export const setWhiteMode = () => {
    return {
        type : SET_WHITE_MODE,
    };
};
